import React, { useState, useEffect } from "react";
import '../Contact/Contact.css';
import { useLocation } from "react-router-dom";
import Why from "../Why/Why";
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import { IoCall } from "react-icons/io5";
import { MdLocationCity } from "react-icons/md";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, [location]);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    destination: "",
    bestTimeToCall: dayjs().set('hour', 10).set('minute', 0).set('second', 0),
    query: "",
  });

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    destination: "",
    bestTimeToCall: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "fullName":
        if (!/^[A-Za-z\s]+$/.test(value)) error = "Full Name should only contain alphabets.";
        break;
      case "email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Invalid email address.";
        break;
      case "phone":
        if (!/^\d{6,15}$/.test(value)) error = "Phone number should be 6 to 15 digits.";
        break;
      case "address":
        if (value.trim() === "") error = "Address is required.";
        break;
      case "destination":
        if (value.trim() === "") error = "Preferred place is required.";
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  const handleTimeChange = (newValue) => {
    setFormData({ ...formData, bestTimeToCall: newValue });
    setErrors({ ...errors, bestTimeToCall: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let formIsValid = true;
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      if (key !== "query" && key !== "bestTimeToCall") {
        const error = validateField(key, formData[key]);
        if (error) {
          formIsValid = false;
          newErrors[key] = error;
        }
      }
    });

    setErrors(newErrors);

    if (formIsValid) {
      setIsSubmitting(true);
      
      // Prepare data for submission
      const submissionData = {
        ...formData,
        bestTimeToCall: formData.bestTimeToCall.format('h:mm A'),
        message_source: "Contact us" 
      };

      emailjs.send('service_e0a4ln5', 'template_wb5x9l4', submissionData, 'EhCUrSkSnhPlmJ6T-')
        .then((response) => {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Form submitted successfully!',
          });
          setIsSubmitting(false);
        }, (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          });
          setIsSubmitting(false);
        });
    }
  };
  const callAdmin = () => {
    window.location.href = 'tel:02038852600';
  };

  return (
    <>
      <div className="post-c">
        <div className="overlay-c">
          <h1 className="text-c">Contact Us</h1>
        </div>
      </div>

      <div id="c-uf" className="contact-section">
        <div className="contact-topbar">
          <img src="/plane.png" alt="Contact" className="contact-image" />
          <h1 className="contact-heading">Submit Your Query Now</h1>
        </div>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-gridd">
              <div className="input-group">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
                {errors.fullName && <p className="error2">{errors.fullName}</p>}
              </div>
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <p className="error2">{errors.email}</p>}
              </div>
              <div className="input-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <p className="error2">{errors.phone}</p>}
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
                {errors.address && <p className="error2">{errors.address}</p>}
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="destination"
                  placeholder="Where do you fancy going?"
                  value={formData.destination}
                  onChange={handleChange}
                  required
                />
                {errors.destination && <p className="error2">{errors.destination}</p>}
              </div>
              <div className="input-group">
              <TimePicker
          label={formData.bestTimeToCall ? '' : 'Best Time to Call'}
          value={formData.bestTimeToCall}
          onChange={handleTimeChange}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: 'transparent' },
                  '&:hover fieldset': { borderColor: 'transparent' },
                  '&.Mui-focused fieldset': { borderColor: 'transparent' },
                  color: '#757575',
                },
                '& .MuiInputLabel-root': { 
                  color: '#757575',
                  // Hide label when value exists
                  display: formData.bestTimeToCall ? 'none' : 'block'
                },
                '& .MuiSvgIcon-root': { color: '#f7901e' },
              },
            },
          }}
        />
                {errors.bestTimeToCall && <p className="error2">{errors.bestTimeToCall}</p>}
              </div>
              
              <textarea
                name="query"
                placeholder="Your Query"
                rows="4"
                value={formData.query}
                onChange={handleChange}
              />
            </div>
            
            <button type="submit" className="send-button" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </LocalizationProvider>
      </div>

      <div className="map-container">
        <h2 className="map-heading">Visit Us</h2>
        <p className="map-description">
          If you would like to discuss your travel plans face to face with a specialist,
          please make an appointment to come and see us in our London office.
        </p>
        <div className="contact-details">
          <h3>Contact Details</h3>
          <p className="contact-number" onClick={callAdmin}><IoCall /> 02038852600</p>
          <p className="contact-address"><MdLocationCity /> International House 45-55 Commercial Street London E1 6BD</p>
        </div>
        <div className="map-frame">
          <iframe
            title="London Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2486.5892614047193!2d-0.1277585842290263!3d51.50735197963557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b30678d3d27%3A0xe404f2d1f3bfc1e7!2sLondon%20Eye!5e0!3m2!1sen!2suk!4v1693748573924!5m2!1sen!2suk"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <Why />
    </>
  );
};

export default Contact;